import { useState, useEffect } from 'react';

interface Props {
  onComplete: () => void;
}

export default function WelcomePage({ onComplete }: Props) {
  const [phase, setPhase] = useState<'logo-fade' | 'logo-shift' | 'text-reveal' | 'hold' | 'fade-out'>('logo-fade');

  useEffect(() => {
    const t1 = setTimeout(() => setPhase('logo-shift'), 800);
    const t2 = setTimeout(() => setPhase('text-reveal'), 1400);
    const t3 = setTimeout(() => setPhase('hold'), 2400);
    const t4 = setTimeout(() => setPhase('fade-out'), 3300);
    const t5 = setTimeout(onComplete, 4000);

    return () => {
      clearTimeout(t1);
      clearTimeout(t2);
      clearTimeout(t3);
      clearTimeout(t4);
      clearTimeout(t5);
    };
  }, [onComplete]);

  return (
    <div
      className={`fixed inset-0 z-[100] flex items-center justify-center transition-opacity duration-500 ${
        phase === 'fade-out' ? 'opacity-0' : 'opacity-100'
      }`}
    >
      <div className="absolute inset-0 bg-cover bg-center bg-no-repeat" style={{ backgroundImage: "url('/assets/images/Background-6.png')" }} />

      <div className="relative flex items-center gap-4">
        <img
          src="/assets/images/App_Icon_White.png"
          alt="X Manage"
          className="w-16 h-16 sm:w-20 sm:h-20 object-contain transition-all duration-500 ease-out"
          style={{
            opacity: phase === 'logo-fade' ? 0 : 1,
            transform: phase === 'logo-fade'
              ? 'translateX(40px) scale(0.9)'
              : phase === 'logo-shift' || phase === 'text-reveal' || phase === 'hold' || phase === 'fade-out'
                ? 'translateX(0) scale(1)'
                : 'translateX(40px) scale(0.9)',
          }}
        />

        <div
          className="flex flex-col transition-all duration-500 ease-out overflow-hidden"
          style={{
            opacity: phase === 'text-reveal' || phase === 'hold' || phase === 'fade-out' ? 1 : 0,
            transform: phase === 'text-reveal' || phase === 'hold' || phase === 'fade-out'
              ? 'translateX(0)'
              : 'translateX(-12px)',
            maxWidth: phase === 'text-reveal' || phase === 'hold' || phase === 'fade-out' ? '300px' : '0px',
          }}
        >
          <span className="text-white text-2xl sm:text-3xl font-bold tracking-widest whitespace-nowrap leading-tight">
            X MANAGE
          </span>
          <span
            className="text-white/70 text-xs sm:text-sm tracking-wide whitespace-nowrap transition-opacity duration-400 ease-out"
            style={{
              opacity: phase === 'hold' || phase === 'fade-out' ? 1 : 0,
            }}
          >
            By Mysterious Brothers
          </span>
        </div>
      </div>
    </div>
  );
}
